import React from "react";
import AuthContextProvider from "./contexts/AuthContext";
import ProcessContextProvider from "./contexts/ProcessContext";
import ConfigContextProvider from "./contexts/ConfigContext";
import NotificationManager from "./components/shared/sharedKernel/NotificationManager";
import AppWrapper from "./components/shared/sharedKernel/AppWrapper";
import AuthLayer from "./components/shared/sharedKernel/AuthLayer";
import ThemeManager from "./components/shared/sharedKernel/ThemeManager";
import EventCatcher from "./components/shared/sharedKernel/EventCatcher/EventCatcher";
import { Outlet } from "react-router-dom";

require("../node_modules/nemuru-components/dist/main-theme.js");

export default function App(props) {
  const { currentPath } = props;

  return (
    <div className="App">
      <AuthContextProvider>
        <ConfigContextProvider>
          <ThemeManager>
            <AppWrapper>
              <ProcessContextProvider>
                <NotificationManager />
                <AuthLayer currentPath={currentPath}>
                  <Outlet />
                </AuthLayer>
                <EventCatcher />
              </ProcessContextProvider>
            </AppWrapper>
          </ThemeManager>
        </ConfigContextProvider>
      </AuthContextProvider>
    </div>
  );
}
